/**
 * @author Michael Hasenstein <hasenstein@yahoo.com>
 * @copyright REFINIO GmbH 2021
 * @license CC-BY-NC-SA-2.5; portions MIT License
 * @version 0.0.1
 */
import { ensurePlatformLoaded } from './platform.js';
let SS;
export function setPlatformForSs(exports) {
    SS = exports;
}
export const SettingsStore = {
    getItem: (key) => {
        ensurePlatformLoaded();
        return SS.SettingsStore.getItem(key);
    },
    setItem: (key, value) => {
        ensurePlatformLoaded();
        return SS.SettingsStore.setItem(key, value);
    },
    removeItem: (key) => {
        ensurePlatformLoaded();
        return SS.SettingsStore.removeItem(key);
    },
    clear: () => {
        ensurePlatformLoaded();
        return SS.SettingsStore.clear();
    }
};
//# sourceMappingURL=settings-store.js.map